// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2njlz","title":"Images45_title__1EKgH","images":"Images45_images__1PiNx"};